module.exports = __webpack_public_path__ + "src/assets/img/st3.843b9466.svg";